import { blockBody, unblockBody } from "../../body";

const menu = document.querySelector(".menu");

export const closeMenu = () => {
  menu.classList.remove("menu_opened");
};

export const toggleMenu = () => {
  menu.classList.toggle("menu_opened");

  if (menu.classList.contains("menu_opened")) {
    blockBody();
  } else {
    unblockBody();
  }
};
